import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { IconArrowNarrowLeft } from '@tabler/icons-react';
import { Button } from '@atoms';
import { GO_BACK_TEXT } from './constants';
import styles from './styles';

interface GoBackButtonProps {
  onClick: () => void;
  text: React.ReactNode;
  backFunction: () => void;
  variant: string;
}

/**
 * GoBackButton component.
 *
 * @param props - The component props.
 * @param props.text - The text content of the button.
 * @param props.backFunction - function to trigger when clicking back button
 * @param props.variant - the type of the button
 * @returns {React.ReactNode} The GoBackButton component.
 */
const GoBackButton = (props: GoBackButtonProps) => {
  const navigate = useNavigate();

  /**
   * Default goBack function
   */
  function goBack() {
    navigate(-1);
  }

  const { backFunction = goBack, text = GO_BACK_TEXT, variant = 'text' } = props;

  const { t } = useTranslation();

  return (
    <Box sx={styles.container}>
      <Button
        onClick={backFunction}
        customStyle={{ text: styles.button }}
        color='primary'
        startIcon={<IconArrowNarrowLeft />}
        variant={variant}
        content={
          <>{typeof text === 'string' ? <Typography variant='h4'>{t(text)}</Typography> : text}</>
        }
      />
    </Box>
  );
};

export default GoBackButton;
